import TaxContainer from "../containers/TaxContainer";

const TaxPage = () => {
    return <TaxContainer />;
};

export default TaxPage;
